module.exports = __webpack_public_path__ + "img/logo-footer.2baf0121.jpg";